import { render, staticRenderFns } from "./received-list.vue?vue&type=template&id=91624cae&"
import script from "./received-list.vue?vue&type=script&lang=js&"
export * from "./received-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports